import type { JSX } from 'react'

import { TopNumber4SC } from './TopNumbers.styled'

export const Top4 = (): JSX.Element => (
  <TopNumber4SC
    width='145'
    height='188'
    viewBox='0 0 145 188'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M145 145.322H116.979V188H87.5985V145.322H0V122.902L1.08818 122.632L0 122.362L87.5985 0H116.979V119.661H145V145.322ZM87.5985 119.661V39.977L33.7336 119.661H87.5985Z'
      fill='url(#paint0_linear_5096_100044)'
    />
    <defs>
      <linearGradient
        id='paint0_linear_5096_100044'
        x1='-13.3302'
        y1='-0.236339'
        x2='173.472'
        y2='168.488'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#EFEFEF' />
        <stop offset='1' stopColor='#7C7984' stopOpacity='0.2' />
      </linearGradient>
    </defs>
  </TopNumber4SC>
)
